import angular from 'angular';
import 'angular-ui-router';
import template from './bidPricesForm.jade';

export class BidPricesFormController {
  /* @ngInject */
  constructor($filter, currentUser) {
    this.translate = $filter('translate');

    this.fields = [
      {
        "fieldGroup": [
          {
            className: 'layout__item u-3/12',
            type: 'input',
            key: 'campaign_id',
            expressionProperties: {
              "templateOptions.label": "'campaign_id' | translate"
            },
            templateOptions: {
              label: '',
              type: 'number'
            }
          },
          {
            className: 'layout__item u-3/12',
            type: 'uiSelect',
            key: 'campaign_type',
            expressionProperties: {
              "templateOptions.label": "'campaign_type' | translate"
            },
            templateOptions: {
              label: '',
              options: [
                {value: 'Engagement', name:'Conversion'},
                {value: 'Acquisition', name:'Acquisition'},
                {value: 'AcquisitionCPM', name:'AcquisitionCPM'},
                {value: 'BrandingCPM', name:'BrandingCPM'},
                {value: null, name:'None'}
              ]
            }
          },
          {
            className: 'layout__item u-3/12',
            type: 'input',
            key: 'country_code',
            expressionProperties: {
              "templateOptions.label": "'country_code' | translate"
            },
            templateOptions: {
              label: ''
            }
          },
          {
            className: 'layout__item u-3/12',
            type: 'uiSelect',
            key: 'platform',
            expressionProperties: {
              "templateOptions.label": "'platform' | translate"
            },
            templateOptions: {
              label: '',
              options: [
                {value: 'Android', name:'Android'},
                {value: 'Android_Smartphone', name:'Android_Smartphone'},
                {value: 'Android_Tablet', name:'Android_Tablet'},
                {value: 'Desktop', name:'Desktop'},
                {value: 'iOS', name:'iOS'},
                {value: 'iPad', name:'iPad'},
                {value: 'iPhone', name:'iPhone'},
                {value: 'Other', name:'Other'},
                {value: null, name:'None'}
              ]
            }
          }
        ]
      },
      {
        "fieldGroup": [
          {
            className: 'layout__item u-3/12',
            type: 'input',
            key: 'creative_id',
            expressionProperties: {
              "templateOptions.label": "'creative_id' | translate"
            },
            templateOptions: {
              label: '',
              type: 'number'
            }
          },
          {
            className: 'layout__item u-3/12',
            type: 'uiSelect',
            key: 'creative_type',
            expressionProperties: {
              "templateOptions.label": "'creative_type' | translate"
            },
            templateOptions: {
              label: '',
              options: [
                {value: 'banner', name:'banner'},
                {value: 'video', name:'video'},
                {value: null, name:'None'}
              ]
            }
          },
          {
            className: 'layout__item u-3/12',
            type: 'uiSelect',
            key: 'creative_dimensions',
            expressionProperties: {
              "templateOptions.label": "'creative_dimensions' | translate"
            },
            templateOptions: {
              label: '',
              options: [
                {name: '120x600', value:'120x600'},
                {name: '160x600', value:'160x600'},
                {name: '168x28', value:'970x90'},
                {name: '200x200', value:'200x200'},
                {name: '250x250', value:'250x250'},
                {name: '240x400', value:'240x400'},
                {name: '300x250', value:'300x250'},
                {name: '300x50', value:'300x50'},
                {name: '300x600', value:'300x600'},
                {name: '320x100', value:'320x100'},
                {name: '320x480', value:'320x480'},
                {name: '320x50', value:'320x50'},
                {name: '336x280', value:'336x280'},
                {name: '360x50', value:'360x50'},
                {name: '360x640', value:'360x640'},
                {name: '375x50', value:'375x50'},
                {name: '468x60', value:'468x60'},
                {name: '480x320', value:'480x320'},
                {name: '640x360', value:'640x360'},
                {name: '728x90', value:'728x90'},
                {name: '768x1024', value:'768x1024'},
                {name: '768x90', value:'768x90'},
                {name: '970x90', value:'970x90'},
                {name: '970x250', value:'970x250'},
                {name: '1024x768', value:'1024x768'},
                {value: null, name:'None'}
              ]
            }
          },
          {
            className: 'layout__item u-3/12',
            type: 'input',
            key: 'channel',
            expressionProperties: {
              "templateOptions.label": "'channel' | translate"
            },
            templateOptions: {
              label: ''
            }
          }
        ]
      },
      {
        "fieldGroup": [
          {
            className: 'layout__item u-3/12',
            type: 'input',
            key: 'publisher',
            expressionProperties: {
              "templateOptions.label": "'publisher' | translate"
            },
            templateOptions: {
              label: ''
            }
          },
          //{
          //  className: 'layout__item u-3/12',
          //  type: 'uiSelect',
          //  key: 'paying',
          //  expressionProperties: {
          //    "templateOptions.label": "'paying' | translate"
          //  },
          //  templateOptions: {
          //    label: '',
          //    options: [
          //      {value: true, name:'Yes'},
          //      {value: false, name:'No'},
          //      {value: null, name:'None'}
          //    ]
          //  }
          //},
          {
            className: 'layout__item u-3/12',
            type: 'uiSelect',
            key: 'day_of_week',
            expressionProperties: {
              "templateOptions.label": "'day_of_week' | translate"
            },
            templateOptions: {
              label: '',
              options: this.buildNumbersOptions([1,2,3,4,5,6,7], true)
            }
          },
          {
            className: 'layout__item u-3/12',
            type: 'uiSelect',
            key: 'hour_of_day',
            expressionProperties: {
              "templateOptions.label": "'hour_of_day' | translate"
            },
            templateOptions: {
              label: '',
              options: this.buildNumbersOptions([0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23], true)
            }
          },
          {
            className: 'layout__item u-3/12',
            type: 'input',
            key: 'nth_impression',
            expressionProperties: {
              "templateOptions.label": "'nth_impression' | translate"
            },
            templateOptions: {
              label: '',
              type: 'number'
            }
          }
        ]
      },
      {
        "fieldGroup": [
          {
            className: 'layout__item u-3/12',
            type: 'input',
            key: 'traffic_source',
            expressionProperties: {
              "templateOptions.label": "'traffic_source' | translate"
            },
            templateOptions: {
              label: ''
            }
          },
          {
            className: 'layout__item u-3/12',
            type: 'uiSelect',
            key: 'gaming_bundle',
            expressionProperties: {
              "templateOptions.label": "'gaming_bundle' | translate"
            },
            templateOptions: {
              label: '',
              options: [
                {value: true, name:'Yes'},
                {value: false, name:'No'},
                {value: null, name:'None'}
              ]
            }
          }
        ]
      }
    ];
  }

  buildNumbersOptions(numbersArr, addNullValue) {
    const arr = _.map(numbersArr, (i) => { return {value: i, name: i}; })
    addNullValue && arr.push({value: null, name:'None'});
    return arr;
  }
}

export function BidPricesFormComponent() {
  return {
    template,
    controller: BidPricesFormController,
    restrict: 'E',
    controllerAs: 'vm',
    scope: {
      resource: '='
    },
    bindToController: true
  };
};

export default angular.module('app.components.admin.bidPrices.form', [])
  .directive('bidPricesForm', BidPricesFormComponent);



/** WEBPACK FOOTER **
 ** ./src/components/admin/bidPrices/bidPricesForm.js
 **/